enum EBackups {
  transferRepoData = 'backups/fetch',
  transferAllData = 'backups/fetch-all',
  matchRepoData = 'backups/match',
  restoreBackup = 'backups/restore',
  restoreBackupAll = 'backups/restore-all',
  restoreBackupGist = 'backups/restore-gist',
  downloadZip = 'backups/download',
  downloadZipLatest = 'backups/download-latest',
  resetBackup = 'backups/reset',
  updateActions = 'backups/update-actions',
  restoreGistBackup = 'backups/restore-gist',
  downloadGistZip = 'backups/download-gist',
  updateUserWorkspace = 'update-user-workspace',
}

export default EBackups;
